import { render } from "./DistributionProtocols.vue?vue&type=template&id=86274f50"
import script from "./DistributionProtocols.vue?vue&type=script&lang=js"
export * from "./DistributionProtocols.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__